function getCurrentLengthValue() {
  // 1) Radio inputs pattern
  const lengthRadio = document.querySelector('[name="options[Length]"]:checked');
  if (lengthRadio && lengthRadio.value) return normalizeLength(lengthRadio.value);

  // 1b) Dynamic radio inputs whose name starts with "length-" (theme-generated)
  const dynLengthRadio = document.querySelector('input[type="radio"][name^="length-"]:checked');
  if (dynLengthRadio && dynLengthRadio.value) return normalizeLength(dynLengthRadio.value);

  // 2) Select dropdown pattern
  const lengthSelect = document.querySelector('select[name="options[Length]"]');
  if (lengthSelect && lengthSelect.value) return normalizeLength(lengthSelect.value);

  // 3) Button group with aria-pressed inside a group labeled as Length
  const pressedInGroup = document.querySelector('[data-option-name="Length"] [aria-pressed="true"]');
  if (pressedInGroup) return normalizeLength(pressedInGroup.textContent.trim());

  // 4) Generic pressed button with accessible label referencing Length
  const genericPressed = Array.from(document.querySelectorAll('[aria-pressed="true"]')).find((el) => {
    const label = (el.getAttribute('aria-label') || el.textContent || '').toLowerCase();
    return label.includes('length');
  });
  if (genericPressed) return normalizeLength(genericPressed.textContent.trim());

  return null;
}

function normalizeLength(value) {
  const digits = String(value).match(/\d{2,3}/);
  return digits ? digits[0] : String(value).trim();
}

function findMatchingVariantByLength(variants, lengthValue) {
  if (!Array.isArray(variants) || !lengthValue) return null;
  const target = normalizeLength(lengthValue);
  const match = variants.find(v => {
    // Look through up to 3 options and match the one that equals Length
    return [v.option1, v.option2, v.option3]
      .filter(Boolean)
      .some(opt => normalizeLength(opt) === target);
  });
  return match || null;
}

function getFormVariants(form) {
  // Prefer JSON script to avoid HTML attribute escaping issues
  const script = form.querySelector('[data-variants-json]');
  if (script && script.textContent) {
    try { return JSON.parse(script.textContent); } catch (_) {}
  }
  // Fallback to data attribute if present
  try { return JSON.parse(form.dataset.variants || '[]'); } catch (_) { return []; }
}

function updateRelatedForm(form, config) {
  const { type, debugClass, buttonSelector, radiosSelector } = config;
  const variants = getFormVariants(form);
  const note = form.querySelector('[data-length-fallback-note]');
  const matchNote = form.querySelector('[data-length-match-note]');
  const requiredNote = form.querySelector('[data-length-required-note]');
  const variantIdInput = form.querySelector('[data-variant-id]');
  const currentLen = getCurrentLengthValue();
  const debug = document.body.classList.contains(debugClass);
  if (debug) {
    console.log(`[${type}] Current curtain Length:`, currentLen);
    console.log(`[${type}] Variants:`, variants.map(v => ({ id: v.id, option1: v.option1, option2: v.option2, option3: v.option3 })));
  }
  // Guard: no Length selected yet -> disable button and show tip
  const submitBtn = form.querySelector(buttonSelector);
  if (!currentLen) {
    if (submitBtn) submitBtn.disabled = true;
    if (requiredNote) requiredNote.hidden = false;
    if (note) note.hidden = true;
    if (matchNote) matchNote.hidden = true;
    return;
  }

  if (requiredNote) requiredNote.hidden = true;

  let chosen = findMatchingVariantByLength(variants, currentLen);

  if (!chosen) {
    chosen = variants.find(v => v.available) || variants[0];
    if (note) note.hidden = false;
    if (matchNote) matchNote.hidden = true;
    if (debug) console.log(`[${type}] No exact match; fallback to variant:`, chosen && chosen.id);
  } else if (note) {
    note.hidden = true;
    if (matchNote) {
      matchNote.textContent = `Auto-selected for ${currentLen} in`;
      matchNote.hidden = false;
    }
  }

  if (chosen && variantIdInput) {
    variantIdInput.value = String(chosen.id);
    if (debug) console.log(`[${type}] Hidden variant id set to:`, variantIdInput.value);
  }

  // Disable submit if variant unavailable
  if (submitBtn) submitBtn.disabled = !(chosen && chosen.available);

  // Sync hidden radios for debug visibility
  const radios = form.querySelectorAll(radiosSelector);
  if (radios && chosen) {
    radios.forEach(r => { r.checked = (String(r.value) === String(chosen.id)); });
  }
}

function updateTrimsetForm(form) {
  updateRelatedForm(form, {
    type: 'TrimSet',
    debugClass: 'trimset-debug',
    buttonSelector: '[data-add-trimset]',
    radiosSelector: '[data-trimset-radios] input[type="radio"]'
  });
}

function updateBaseLayerForm(form) {
  updateRelatedForm(form, {
    type: 'BaseLayer',
    debugClass: 'baselayer-debug',
    buttonSelector: '[data-add-baselayer]',
    radiosSelector: '[data-baselayer-radios] input[type="radio"]'
  });
}

function initRelatedTrimsets() {
  const forms = Array.from(document.querySelectorAll('[data-trimset-form]'));
  if (forms.length === 0) return;

  // Initial update
  forms.forEach(updateTrimsetForm);

  // Listen to curtain Length changes
  const lengthInputs = document.querySelectorAll('[name="options[Length]"], select[name="options[Length]"], [data-option-name="Length"] [role="button"], [data-option-name="Length"] input');
  lengthInputs.forEach((el) => {
    el.addEventListener('change', () => forms.forEach(updateTrimsetForm));
    el.addEventListener('click', () => forms.forEach(updateTrimsetForm));
  });

  // Event delegation for dynamic name="length-*" radios
  document.addEventListener('change', (ev) => {
    const t = ev.target;
    if (t && t.matches('input[type="radio"][name^="length-"]')) {
      forms.forEach(updateTrimsetForm);
      if (document.body.classList.contains('trimset-debug')) {
        console.log('[TrimSet] Detected change on dynamic length radio name:', t.name, 'value:', t.value);
      }
    }
  });

  // Also observe DOM changes on variant picker (safety)
  const variantPicker = document.querySelector('variant-picker, [data-variant-picker]') || document;
  const observer = new MutationObserver(() => {
    forms.forEach(updateTrimsetForm);
  });
  observer.observe(variantPicker, { subtree: true, childList: true, attributes: true });

  // Ensure correct variant is applied right before submission
  forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      updateTrimsetForm(form);
      const variantIdInput = form.querySelector('[data-variant-id]');
      const btn = form.querySelector('[data-add-trimset]');
      const addText = form.querySelector('[data-add-text]');
      const addedText = form.querySelector('[data-added-text]');
      const live = form.querySelector('[data-trimset-live]');
      const debug = document.body.classList.contains('trimset-debug');
      if (debug) {
        console.log('[TrimSet] Submit variant id:', variantIdInput && variantIdInput.value);
      }

      const formData = new FormData(form);
      // UI: loading state
      if (btn) {
        btn.classList.add('atc-adding');
        btn.disabled = true;
      }
      const originalText = addText && addText.textContent;
      if (addText) addText.textContent = 'Adding...';
      try {
        // Include sections used by cart (mirrors product-form behavior)
        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionIds = [];
        cartItemsComponents.forEach((el) => {
          if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });
        if (sectionIds.length) formData.append('sections', sectionIds.join(','));
      } catch (_) {}

      const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      fetch(url, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'text/html' },
      })
        .then((r) => r.json())
        .then((response) => {
          if (response && response.status) {
            document.dispatchEvent(new CustomEvent('cart:error', { detail: response }));
            if (debug) console.warn('[TrimSet] Cart add error', response);
            return;
          }
          // Signal cart updated -> cart drawer will auto-open via CartAddEvent
          const id = formData.get('id');
          // Always shape detail like CartAddEvent => { resource, sourceId, data: { ... } }
          const detail = {
            resource: {},
            sourceId: String(id || ''),
            data: {
              source: 'related-trimset',
              sections: response && response.sections ? response.sections : {},
              variantId: id,
            },
          };
          document.dispatchEvent(new CustomEvent('cart:update', { detail }));
          // UI: success feedback
          if (btn) {
            btn.classList.remove('atc-adding');
            btn.classList.add('atc-added');
            setTimeout(() => btn.classList.remove('atc-added'), 600);
            btn.disabled = false;
          }
          if (addText) {
            const msg = (addedText && addedText.textContent) || 'Added';
            if (live) live.textContent = msg;
            addText.textContent = msg;
            setTimeout(() => {
              if (typeof originalText === 'string') addText.textContent = originalText;
              if (live) live.textContent = '';
            }, 2000);
          }
        })
        .catch((err) => {
          if (debug) console.error('[TrimSet] Add error', err);
          // UI: restore on error
          if (btn) {
            btn.classList.remove('atc-adding');
            btn.disabled = false;
          }
          if (addText && typeof originalText === 'string') addText.textContent = originalText;
        });
    });

    // Allow selecting via debug radios to force variant
    form.addEventListener('change', (ev) => {
      const target = ev.target;
      if (target && target.matches('[data-trimset-radios] input[type="radio"], [data-trimset-radios] input[type="radio"] *')) {
        const variantIdInput = form.querySelector('[data-variant-id]');
        if (variantIdInput && target.value) {
          variantIdInput.value = String(target.value);
          if (document.body.classList.contains('trimset-debug')) {
            console.log('[TrimSet] Radio-chosen variant id:', variantIdInput.value);
          }
        }
      }
    });
  });

  // Listen to common custom events themes fire on variant change
  const reSync = () => forms.forEach(updateTrimsetForm);
  ['variant:change', 'variant:changed', 'product:variant-change', 'theme:variant:change']
    .forEach((evt) => document.addEventListener(evt, reSync));

  // Observe hidden main product variant id input for changes (attribute & mutations)
  const mainVariantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  if (mainVariantInput) {
    const inputObserver = new MutationObserver(reSync);
    inputObserver.observe(mainVariantInput, { attributes: true, attributeFilter: ['value'] });
    mainVariantInput.addEventListener('change', reSync);
  }

  // Lightweight polling fallback for themes that update only the input property
  let lastLength = getCurrentLengthValue();
  setInterval(() => {
    const curr = getCurrentLengthValue();
    if (curr !== lastLength) {
      lastLength = curr;
      reSync();
      if (document.body.classList.contains('trimset-debug')) {
        console.log('[TrimSet] Poll detected Length change:', curr);
      }
    }
  }, 300);
}

function initRelatedBaseLayer() {
  const forms = Array.from(document.querySelectorAll('[data-baselayer-form]'));
  if (forms.length === 0) return;

  // Initial update
  forms.forEach(updateBaseLayerForm);

  // Listen to curtain Length changes
  const lengthInputs = document.querySelectorAll('[name="options[Length]"], select[name="options[Length]"], [data-option-name="Length"] [role="button"], [data-option-name="Length"] input');
  lengthInputs.forEach((el) => {
    el.addEventListener('change', () => forms.forEach(updateBaseLayerForm));
    el.addEventListener('click', () => forms.forEach(updateBaseLayerForm));
  });

  // Event delegation for dynamic name="length-*" radios
  document.addEventListener('change', (ev) => {
    const t = ev.target;
    if (t && t.matches('input[type="radio"][name^="length-"]')) {
      forms.forEach(updateBaseLayerForm);
      if (document.body.classList.contains('baselayer-debug')) {
        console.log('[BaseLayer] Detected change on dynamic length radio name:', t.name, 'value:', t.value);
      }
    }
  });

  // Also observe DOM changes on variant picker (safety)
  const variantPicker = document.querySelector('variant-picker, [data-variant-picker]') || document;
  const observer = new MutationObserver(() => {
    forms.forEach(updateBaseLayerForm);
  });
  observer.observe(variantPicker, { subtree: true, childList: true, attributes: true });

  // Ensure correct variant is applied right before submission
  forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      updateBaseLayerForm(form);
      const variantIdInput = form.querySelector('[data-variant-id]');
      const btn = form.querySelector('[data-add-baselayer]');
      const addText = form.querySelector('[data-add-text]');
      const addedText = form.querySelector('[data-added-text]');
      const live = form.querySelector('[data-baselayer-live]');
      const debug = document.body.classList.contains('baselayer-debug');
      if (debug) {
        console.log('[BaseLayer] Submit variant id:', variantIdInput && variantIdInput.value);
      }

      const formData = new FormData(form);
      // UI: loading state
      if (btn) {
        btn.classList.add('atc-adding');
        btn.disabled = true;
      }
      const originalText = addText && addText.textContent;
      if (addText) addText.textContent = 'Adding...';
      try {
        // Include sections used by cart (mirrors product-form behavior)
        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionIds = [];
        cartItemsComponents.forEach((el) => {
          if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });
        if (sectionIds.length) formData.append('sections', sectionIds.join(','));
      } catch (_) {}

      const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      fetch(url, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'text/html' },
      })
        .then((r) => r.json())
        .then((response) => {
          if (response && response.status) {
            document.dispatchEvent(new CustomEvent('cart:error', { detail: response }));
            if (debug) console.warn('[BaseLayer] Cart add error', response);
            return;
          }
          // Signal cart updated -> cart drawer will auto-open via CartAddEvent
          const id = formData.get('id');
          // Always shape detail like CartAddEvent => { resource, sourceId, data: { ... } }
          const detail = {
            resource: {},
            sourceId: String(id || ''),
            data: {
              source: 'related-baselayer',
              sections: response && response.sections ? response.sections : {},
              variantId: id,
            },
          };
          document.dispatchEvent(new CustomEvent('cart:update', { detail }));
          // UI: success feedback
          if (btn) {
            btn.classList.remove('atc-adding');
            btn.classList.add('atc-added');
            setTimeout(() => btn.classList.remove('atc-added'), 600);
            btn.disabled = false;
          }
          if (addText) {
            const msg = (addedText && addedText.textContent) || 'Added';
            if (live) live.textContent = msg;
            addText.textContent = msg;
            setTimeout(() => {
              if (typeof originalText === 'string') addText.textContent = originalText;
              if (live) live.textContent = '';
            }, 2000);
          }
        })
        .catch((err) => {
          if (debug) console.error('[BaseLayer] Add error', err);
          // UI: restore on error
          if (btn) {
            btn.classList.remove('atc-adding');
            btn.disabled = false;
          }
          if (addText && typeof originalText === 'string') addText.textContent = originalText;
        });
    });

    // Allow selecting via debug radios to force variant
    form.addEventListener('change', (ev) => {
      const target = ev.target;
      if (target && target.matches('[data-baselayer-radios] input[type="radio"], [data-baselayer-radios] input[type="radio"] *')) {
        const variantIdInput = form.querySelector('[data-variant-id]');
        if (variantIdInput && target.value) {
          variantIdInput.value = String(target.value);
          if (document.body.classList.contains('baselayer-debug')) {
            console.log('[BaseLayer] Radio-chosen variant id:', variantIdInput.value);
          }
        }
      }
    });
  });

  // Listen to common custom events themes fire on variant change
  const reSync = () => forms.forEach(updateBaseLayerForm);
  ['variant:change', 'variant:changed', 'product:variant-change', 'theme:variant:change']
    .forEach((evt) => document.addEventListener(evt, reSync));

  // Observe hidden main product variant id input for changes (attribute & mutations)
  const mainVariantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  if (mainVariantInput) {
    const inputObserver = new MutationObserver(reSync);
    inputObserver.observe(mainVariantInput, { attributes: true, attributeFilter: ['value'] });
    mainVariantInput.addEventListener('change', reSync);
  }

  // Lightweight polling fallback for themes that update only the input property
  let lastLength = getCurrentLengthValue();
  setInterval(() => {
    const curr = getCurrentLengthValue();
    if (curr !== lastLength) {
      lastLength = curr;
      reSync();
      if (document.body.classList.contains('baselayer-debug')) {
        console.log('[BaseLayer] Poll detected Length change:', curr);
      }
    }
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initRelatedTrimsets();
    initRelatedBaseLayer();
  });
} else {
  initRelatedTrimsets();
  initRelatedBaseLayer();
}


